import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  appId: "yerin",
  general: {
    email: "yerin@iyk.app",
    name: "Yerin",
    baseUrl: "https://yerin.iyk.app",
  },
  meta: {
    description: "Yerin",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://www.instagram.com/every__nn",
    },
    {
      label: "X",
      logo: UI.Icon.X,
      href: "https://x.com/yerin_official_",
    },
    {
      label: "Website",
      logo: UI.Icon.Globe,
      href: "https://asidecompany.com",
    },
  ],
})

interface Config {
  appId: string
  general: {
    email: string
    name: string
    baseUrl: string
  }
  meta: {
    description: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
